import { render, staticRenderFns } from "./CreatedTicketNotification.vue?vue&type=template&id=57d905ef&scoped=true&"
import script from "./CreatedTicketNotification.vue?vue&type=script&lang=js&"
export * from "./CreatedTicketNotification.vue?vue&type=script&lang=js&"
import style0 from "./CreatedTicketNotification.vue?vue&type=style&index=0&id=57d905ef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d905ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VRow,VSpacer})
